"use client";
import { PropsWithChildren } from "react";
import { deviceDetector } from "@ospweb/sdk-ui";
import { useIsPc } from "@/src/hooks/useIsPc";
interface ShowOnPcOrMobileProps {
  showMode?: "pc" | "mobile" | "all";
  hideOnMobileApp?: boolean;
}

export const ShowOnPcOrMobile = ({
  children,
  showMode = "all",
  hideOnMobileApp = false,
}: PropsWithChildren<ShowOnPcOrMobileProps>) => {
  const [isPc] = useIsPc();
  if (hideOnMobileApp && deviceDetector.isMobile()) {
    return null;
  }
  if (showMode === "pc") {
    return isPc ? children : null;
  }
  if (showMode === "mobile") {
    return !isPc ? children : null;
  }
  return children;
};
